module.exports = "/assets/data/1abe3b1702bb520178432518ca0692a8-YO11.data.json";